import { CommonModule } from '@angular/common';
import { Component, input, computed, ChangeDetectionStrategy } from '@angular/core';
import { ChartModule } from '@progress/kendo-angular-charts';
import { ThreatCampaignResponse } from 'src/app/core/models/analytics/es-models';

@Component({
  selector: 'app-es-threat-campaign-chart',
  standalone: true,
  imports: [CommonModule, ChartModule],
  templateUrl: './es-threat-campaign-chart.component.html',
  styleUrl: './es-threat-campaign-chart.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EsThreatCampaignChartComponent {
  threatCampaignResponse = input<ThreatCampaignResponse>();

  // Computed properties for better template readability
  hasTopSender = computed(() => {
    const sender = this.threatCampaignResponse()?.top_suspicious_sender;
    return sender && sender.trim() !== '';
  });

  formattedIndicators = computed(() => {
    const indicators = this.threatCampaignResponse()?.indicators || [];
    return indicators.length > 0 ? indicators.join(', ') : 'None detected';
  });

  // Chart data for top suspicious senders
  topSendersChartData = computed(() => {
    const senders = this.threatCampaignResponse()?.top_suspicious_senders || [];
    return senders.slice(0, 5).map((sender) => ({
      sender: this.truncateEmail(sender.sender),
      volume: sender.volume,
    }));
  });

  private truncateEmail(email: string): string {
    if (email.length <= 25) return email;
    const [localPart, domain] = email.split('@');
    if (localPart.length > 12) {
      return `${localPart.substring(0, 10)}...@${domain}`;
    }
    if (email.length > 30) {
      return `${email.substring(0, 27)}...`;
    }
    return email;
  }
}
